import React, { useCallback } from 'react'

import { Input } from '../../../components/Input'

import styles from './Slides.module.css'
import { IButtonsProps } from './Buttons'
import {Select} from "../../../components/Select";
import { Attachments } from '../../../components/Attachments'
import {countries, currencies, EMAIL_REGEX, useAllCurrencyOptions} from "../../../constants";
import {Recaptcha} from "../../../components/Recaptcha";
import { Checkbox } from '../../../components/Checkbox'
import { useFormState } from 'react-final-form'
import { Telephone } from "../../../components/Telephone";
import { Popover, OverlayTrigger, Button } from 'react-bootstrap';
import { Radio } from '../../../components/Radio'

export const Signature: React.FC<IButtonsProps> = (props) => {
    let isInvalidField = document.getElementsByClassName('is-invalid')

    function checkIfInvalid () {
      if (isInvalidField.length > 0) {
        document.getElementsByClassName('is-invalid')[0].scrollIntoView({ behavior: 'smooth' });
      }
    }

    const formState = useFormState()

    const isOibValid = (oib:string): boolean => {
        if (!/^[0-9]{11}$/.test(oib))
            return false;

        let a = 10;
        for(const digit of oib.substring(0, 10)) {
            a += parseInt(digit);
            a %= 10;
            if (a === 0)
                a = 10;
            a *= 2;
            a %= 11;
        }

        let kontrolni = 11 - a;
        if (kontrolni === 10)
            kontrolni = 0;

        return kontrolni === parseInt(oib.substr(10, 1));
    }

    const resetPensionValue = useCallback((value: string | null, _allValues: any) => {
        if (value === "nePrimamInoMirovinu") {
            _allValues['txtIznos1'] = ""
            _allValues['txtValuta1'] = ""
            _allValues['txtDrzava1'] = ""
            _allValues['txtIznos2'] = ""
            _allValues['txtValuta2'] = ""
            _allValues['txtDrzava2'] = ""
            _allValues['txtIznos3'] = ""
            _allValues['txtValuta3'] = ""
            _allValues['txtDrzava3'] = ""
            _allValues['txtIBAN'] = null
        }
        if(value === "primamInoMirovinu"){
            _allValues['txtDrzava1'] = null
            _allValues['txtDrzava2'] = null
            _allValues['txtDrzava3'] = null
            _allValues['txtIBAN'] = null
        }
    }, [])

    const cifraValidator = useCallback((value: string | null, _allValues: any) => {
        if (value == null) {
            return 'Obavezno polje'
        } else if (!isOibValid(value)) {
            return 'Molimo upišite točan OIB (11 znamenki)!'
        } else {
            return undefined
        }
    }, [])

    const iznosValidator = useCallback((value: string | null) => {
        if (value != null && parseFloat(value) <= 0) {
            return 'Molimo upišite broj veći od nule'
        } else {
            return undefined
        }
    }, [])

    const valuta2Validator = useCallback((value: string | null, _allValues: any) => {
        if (_allValues['txtIznos2'] != null && _allValues['txtIznos2'] !== '' && !value) {
            return 'Obavezno polje'
        } else {
            return undefined
        }
    }, [])

    const valuta3Validator = useCallback((value: string | null, _allValues: any) => {
        if (_allValues['txtIznos3'] != null  && _allValues['txtIznos3'] !== ''&& !value) {
            return 'Obavezno polje'
        } else {
            return undefined
        }
    }, [])

    const drzava2Validator = useCallback((value: string | null, _allValues: any) => {
        if (_allValues['txtIznos2'] != null && _allValues['txtIznos2'] !== '' && !value) {
            return 'Obavezno polje'
        } else {
            return undefined
        }
    }, [])

    const drzava3Validator = useCallback((value: string | null, _allValues: any) => {
        if (_allValues['txtIznos3'] != null  && _allValues['txtIznos3'] !== ''&& !value) {
            return 'Obavezno polje'
        } else {
            return undefined
        }
    }, [])

    const emailValidator = useCallback((value: string) => {
        if (!(value?.length > 0)) {
            return undefined
        }
        if (EMAIL_REGEX.test(value)) {
            return undefined
        } else {
            return 'Neispravna e-mail adresa'
        }
    }, [])

    const attachmentsValidate = useCallback((value: HTMLImageElement[] | null, _allValues: any) => {
        if ((_allValues['txtHrMirovina'] === 'nePrimamHrMirovinu' || _allValues['txtInoMirovina'] === 'primamInoMirovinu') && (value == null || value.length === 0)) {
            return 'Obavezno polje'
        } else {
            return undefined
        }
    }, [])

    function validateIban(input: string) {
        const codeLengths = {
            HR: 21,
        };
        const iban = input.toUpperCase().replace(/[^A-Z0-9]/g, "");
        const code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/);
        if (!code || iban.length !== (codeLengths as any)[code[1]]) {
            return 'Uneseni IBAN nije ispravan.';
        }
        const digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, (letter: string) => {
            return (letter.charCodeAt(0) - 55).toString();
        });
        if(mod97(digits) === 1){
            return undefined
        } else {
            return 'Uneseni IBAN nije ispravan.'
        }
    }

    function mod97(digital: number | string) {
        digital = digital.toString();
        let checksum: number | string = digital.slice(0, 2);
        let fragment = "";
        for (let offset = 2; offset < digital.length; offset += 7) {
            fragment = checksum + digital.substring(offset, offset + 7);
            checksum = parseInt(fragment, 10) % 97;
        }
        return checksum;
    }

    const popoverDatumRodjenja = (
        <Popover id="popover-basic" className="popover-info">
          <Popover.Content>
            {<b>Molimo upisati dan, mjesec i godinu rođenja u ispravna polja bez točke.</b>} {<br/>}
          </Popover.Content>
        </Popover>
      );

      const InfoDatumRodjenja = () => (
        <OverlayTrigger trigger="click" placement="top" overlay={popoverDatumRodjenja}>
          <Button variant="popover-button datum-rodjenja-button"><i className="fa fa-question"></i></Button>
        </OverlayTrigger>
      );

    return (
        <div className={styles.Wrapper}>
            <h4 className={styles.Title}>
                {'Obrazac za dostavu podatka o visini inozemne mirovine'}
            </h4>

            <div className={styles.Statement} style={{width:"100%", textAlign:"center", textDecoration:"underline"}}>
                {'* Obavezan podatak'}
                <br />
                <hr />
                <a href="https://www.mirovinsko.hr/hr/isplata-jednokratnog-novcanog-primanja-korisnicima-mirovine-radi-ublazavanja-posljedica-rasta-troskova-zivota-pocinje-28-prosinca/3245" target="_blank">
                    Troškovi života
                </a>
                <hr />
            </div>

            <div style={{marginBottom: "20px"}}>
                <Radio
                    label={'Primam mirovinu iz Republike Hrvatske*'}
                    name='txtHrMirovina'
                    value='primamHrMirovinu' /* Choice1 */

                />

                <br />

                <Radio
                    label={'Ne primam mirovinu iz Republike Hrvatske*'}
                    name='txtHrMirovina'
                    value='nePrimamHrMirovinu' /* Choice1 */
                />
            </div>

            <hr style={{width: "100%"}}/>

            {formState.values['txtHrMirovina'] &&
                <>
                    <Input
                    name='txtIme'
                    label={'Ime:'}
                    />

                    <Input
                    name='txtPrezime'
                    label={'Prezime:'}
                    />

                <div style={{textAlign:"left", marginBottom: "6px", marginTop: "6px"}}>
                {'Datum rođenja:'}
                <InfoDatumRodjenja />
                </div>
                <div className='dob-container'>
                <Input
                name='txtDan'
                type={"number"}
                min={1}
                max={31}
                placeholder={'DD'}
                label={'Dan:'}
                />
                <Input
                name='txtMjesec'
                type={"number"}
                min={1}
                max={12}
                placeholder={'MM'}
                label={'Mjesec:'}
                />
                <Input
                name='txtGodina'
                type={"number"}
                min={1800}
                max={2021}
                placeholder={'GGGG'}
                label={'Godina:'}
                />
                </div>

                <Input
                name='txtOIB'
                label={'OIB:'}
                maxLength={11}
                validate={cifraValidator}
                type={"number"}
                />

                    {formState.values['txtHrMirovina'] === 'nePrimamHrMirovinu' && <Input
                        name='txtIBAN'
                        label={'IBAN:'}
                        validate={validateIban}
                        type={"text"}
                    />}

                <Telephone
                name='txtMobitel'
                label={'Kontakt broj:'}
                optional={true}
                />

                <Input
                name='txtEmail'
                label={'E-mail:'}
                validate={emailValidator}
                />
                <br />

                    {formState.values['txtHrMirovina'] === 'primamHrMirovinu' && <div style={{width: "100%", marginBottom: "20px"}}>
                        <Radio
                            label={'Izjavljujem da primam inozemnu mirovinu*'}
                            name='txtInoMirovina'
                            value='primamInoMirovinu' /* Choice1 */
                            validate={formState.values['txtHrMirovina'] === 'nePrimamHrMirovinu' ? undefined : resetPensionValue}
                            optional={formState.values['txtHrMirovina'] === 'nePrimamHrMirovinu'}
                        />

                        <br/>

                        <Radio
                            label={'Izjavljujem da ne primam inozemnu mirovinu*'}
                            name='txtInoMirovina'
                            value='nePrimamInoMirovinu' /* Choice1 */
                            validate={formState.values['txtHrMirovina'] === 'nePrimamHrMirovinu' ? undefined : resetPensionValue}
                            optional={formState.values['txtHrMirovina'] === 'nePrimamHrMirovinu'}
                        />
                    </div>}

                {(formState.values.txtHrMirovina === "nePrimamHrMirovinu" || formState.values.txtInoMirovina === "primamInoMirovinu") &&
                    <div className='show-mirovine'>
                <div className="input-group mb-3"
                style={{display: 'flex', flexFlow: 'row', paddingLeft: '25px', width: '100%'}}>
                <Input
                name='txtIznos1'
                label={'Iznos inozemne mirovine:'}
                placeholder={'0.00'}
                validate={iznosValidator}
                />
                <Select
                name='txtValuta1'
                label={
                `Valuta inozemne mirovine:`
                }
                options={currencies}
                placeholder={'Odaberi'}
                />
                </div>
                        {formState.values.txtHrMirovina !== 'primamHrMirovinu' && <div style={{marginBottom: "10px"}}>
                        <Select
                        name='txtDrzava1'
                        options={countries}
                        label={
                            `Država:`
                        }
                        placeholder={'Odaberi'}
                        className={"state-select"}
                    />
                </div>}
                <hr/>
                <div className="input-group mb-3" style={{display: 'flex', flexFlow: 'row', paddingLeft: '25px'}}>
                <Input
                name='txtIznos2'
                placeholder={'0.00'}
                label={'Iznos inozemne mirovine:'}
                optional
                validate={iznosValidator}
                />
                <Select
                name='txtValuta2'
                options={currencies}
                label={
                `Valuta inozemne mirovine:`
                }
                placeholder={'Odaberi'}
                optional
                validate={valuta2Validator}
                />
                </div>
                        {formState.values.txtHrMirovina !== 'primamHrMirovinu' && <div style={{marginBottom: "10px"}}>
                <Select
                name='txtDrzava2'
                options={countries}
                placeholder={'Odaberi'}
                label={
                `Država:`
                }
                optional
                validate={drzava2Validator}
                className={"state-select"}
                />
                </div>}
                <hr/>
                <div className="input-group mb-3" style={{display: 'flex', flexFlow: 'row', paddingLeft: '25px'}}>
                <Input
                name='txtIznos3'
                placeholder={'0.00'}
                label={'Iznos inozemne mirovine:'}
                optional
                validate={iznosValidator}
                />
                <Select
                name='txtValuta3'
                options={currencies}
                label={
                `Valuta inozemne mirovine:`
                }
                placeholder={'Odaberi'}
                optional
                validate={valuta3Validator}
                />
                </div>
                        {formState.values.txtHrMirovina !== 'primamHrMirovinu' && <div style={{marginBottom: "10px"}}>
                <Select
                name='txtDrzava3'
                options={countries}
                placeholder={'Odaberi'}
                label={
                `Država:`
                }
                optional
                validate={drzava3Validator}
                className={"state-select"}
                />
                </div>}
                <hr/>
                </div>}

                <Attachments
                name='attachments'
                label={'Prilozi:'}
                validate={attachmentsValidate}
                optional
                />

                <Checkbox
                name='chkOdgovornost'
                label={'Pod materijalnom i kaznenom odgovornošću, jamčim za istinitost i točnost svih podataka koji su navedeni u obrascu, kao i u prilozima obrasca.'}
                />

                {<Recaptcha label={"Kontrolni kod:"} name={"captcha-answer"} placeholder={"Prepišite kontrolni kod sa slike"}/>}
                <button
                type="submit"
                className='btn btn-success btn-lg'
                id="submitButton"
                onClick={checkIfInvalid}
                >
                {'Predaj zahtjev'}
                </button>
                </>}

            { /* TODO: move these guys to a modal */ }
        </div>
    )
}
